import 'dayjs/locale/fr';
import { useTranslation } from 'react-i18next';
import Button from 'common/components/Button/Button';
import { Department } from 'types/Department';

const containerStyle =
  'white-box flex px-4 py-2 mb-2 w-full relative cursor-pointer transition-all overflow-hidden';

function DepartmentItem({ item, onDelete, onNavigate }: any) {
  const { name, CP, establishments = [] } = item as Department;

  const { t } = useTranslation();

  return (
    <div className={`${containerStyle}  items-start lg:items-stretch flex-col lg:flex-row`}>
      <div className="w-full">
        <div className="responsive-flex-lg h-full items-center mb-4 lg:mb-0 w-full gap-2 lg:gap-4 pr:0 lg:pr-4">
          <div className="flex flex-col w-full pl-4 justify-start overflow-hidden">
            {/* head */}
            <div className="flex flex-col xl:flex-row w-full gap-4">
              <div className="flex flex-row justify-start w-full">
                <h4 className="text-xl font-bold text-primary leading-6 flex-1">
                  {String(CP).padStart(2, '0')} - {name}
                </h4>
                {establishments.length > 0 ? (
                  <h4 className="text-lgfont-bold text-primary leading-6">
                    {t('forms.nbEstablishments', {
                      count: establishments.length,
                      plural: establishments.length > 1 ? 's' : '',
                    })}
                  </h4>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* right */}
      <div className="flex flex-col justify-between text-xs w-full lg:border-l lg:pl-4 lg:w-[30em] lg:border-slate-150 gap-2">
        <div className="flex w-full gap-1 justify-end">
          <Button
            type="error-line"
            icon="TrashIcon"
            compact
            onClick={() => onDelete(item.id)}
            confirmMessage={t('actions.confirmDelete')}
          />

          <Button
            title={t('actions.edit')}
            type="warning-line"
            icon="PencilSquareIcon"
            onClick={() => onNavigate(item.id)}
          />
        </div>
      </div>
    </div>
  );
}

export default DepartmentItem;
